import './about.css';
import Testimonials from "./Testimonials";

export default function About() {
  return (
    <div className="aboutPage">
      <section className="heading">
        <div className='text'>
          {/* <small>A few Words...</small> */}
          <h1>About Us</h1>
        </div>
      </section>

      {/* Image before Testimonials */}
      <div className="aboutImageContainer">
        <img src="/assets/contact/banner.webp" alt="About Us" className="aboutImage" />
      </div>

      <Testimonials />
    </div>
  );
}
